import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class TipoDescodificadorService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'tipo-descodificacao');
  }


  

}
